import classNames from 'classnames';
import { bool } from 'prop-types';

import ButtonIcon, { propTypes } from '~/components/ButtonIcons/ButtonIcon';

import { ReactComponent as ChevronLeft } from '~/assets/images/iconsLibrary/chevron-left.svg';

import styles from './ButtonIcon.module.scss';

const ChevronLeftButton = ({ className = '', background = true, ...props }) => (
  <ButtonIcon
    {...props}
    className={classNames(
      styles.button,
      background && styles.background,
      className,
    )}
  >
    <ChevronLeft />
  </ButtonIcon>
);
ChevronLeftButton.propTypes = {
  ...propTypes,
  background: bool,
};

export default ChevronLeftButton;
